const fallbackWhatsAppNumber = "5519983951300";
const fallbackWhatsAppMessage =
  "Ola! Preciso de ajuda com uma reserva no Melhores Retiros.";

export const companyContact = {
  whatsappNumber:
    import.meta.env.VITE_WHATSAPP_NUMBER?.trim() || fallbackWhatsAppNumber,
  whatsappMessage:
    import.meta.env.VITE_WHATSAPP_MESSAGE?.trim() || fallbackWhatsAppMessage,
  supportEmail:
    import.meta.env.VITE_SUPPORT_EMAIL?.trim() || "contato@melhoresretiros.com.br",
  helpCenterPath: "/central-de-ajuda#faq",
};

export const buildWhatsAppUrl = (message = companyContact.whatsappMessage) =>
  `https://wa.me/${companyContact.whatsappNumber}?text=${encodeURIComponent(message)}`;
